var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNvidia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "150px",
    height: "150px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.04297,9.00391c-0.552,0 -1,0.449 -1,1v2.09961c0.654,-0.066 1.32195,-0.09961 2.00195,-0.09961c8.168,0 14.1518,4.59474 18.7168,9.30273c0.356,0.368 0.37683,0.94684 0.04883,1.33984c-4.81,5.75 -10.77058,10.35742 -17.76758,10.35742h-0.05078c-1.03932,-0.05197 -2.02271,-0.19227 -2.95117,-0.41602v-3.0957c0.91852,0.32362 1.91868,0.50977 3,0.50977c4.108,0 9.799,-3.32 13,-8c-2.525,-3.237 -9.228,-7 -14,-7c-0.65874,0 -1.32635,0.05746 -1.99805,0.16406v-3.0625c-6.995,0.703 -12.69153,4.98286 -17.64453,9.13086c-0.32,0.268 -0.43978,0.70856 -0.30078,1.10156c2.8348,8.02542 9.06243,15.12653 17.94141,16.44727l0.00195,2.21875c0,0.552 0.448,0.999 1,1h30.00195c0.551,0 1,-0.448 1,-1v-30.99805c0,-0.551 -0.449,-1 -1,-1zM18.03906,15.16602v2.88672c-3.34861,0.3311 -6.55109,2.26631 -9.58594,4.48047c-0.388,0.283 -0.51945,0.80333 -0.31445,1.23633c2.23069,4.71635 5.43835,7.74097 9.90039,8.81836v3.01758c-6.51836,-1.66974 -12.8192,-8.22892 -13.99609,-12.60352c3.85203,-3.5741 9.05022,-7.05377 13.99609,-7.83594zM19.04102,18.00195c4.13,0 7.43022,1.06616 9.69922,3.28516l-4.69922,3.71484c-0.579,-1.611 -2.644,-4 -5,-4c-0.31682,0 -0.65242,0.03989 -0.99805,0.10742v-3.05664c0.33072,-0.03374 0.66335,-0.05078 0.99805,-0.05078zM18.03906,21.11133v8.38086c-2.78311,-0.98332 -4.80434,-3.2437 -5.99609,-5.49023c1.58694,-1.07528 3.98193,-2.49651 5.99609,-2.89062zM40.04297,26.00391l5.69141,3.72266c-5.132,4.92 -14.70041,9.27734 -24.69141,9.27734c-1.03133,0 -2.03354,-0.07689 -3.00195,-0.2207v-3.17773c1.00138,0.25669 2.00757,0.39844 3.00195,0.39844c6.899,0 14.487,-5.352 19,-10z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNvidia);
export default __webpack_public_path__ + "static/media/nvidia.d6277a3d425b694dfed4ee8a862c10ca.svg";
export { ForwardRef as ReactComponent };